import PoolsApi from '../api/pools'
import { addInfoNotification, addErrorNotification } from './notifications'
import { HIDE_MODAL } from './modal'

export const UPDATE_POOL_THRESHOLDS = 'UPDATE_POOL_THRESHOLDS'

export const updatePoolThresholds = (id, ThresholdObject, isValuesDefined) => {
  return dispatch => {

    dispatch({
      type: HIDE_MODAL
    })
    
    if (isValuesDefined) {
      PoolsApi.UpdateThresholds(id, ThresholdObject)
        .then(response => {
          if (response.ok) {
            dispatch(addInfoNotification('Pool thresholds were successfully updated'))
          }
          else{
            dispatch(addErrorNotification('Error updating pool thresholds', response.statusText))
          }
        })
        .catch(error => {
          dispatch(addErrorNotification('Error updating pool thresholds', error.message))
          console.log('Catch fetch error: ', error)
        })
    } else {
      PoolsApi.DeleteThresholds(id)
        .then(response => {
          if (response.ok) {
            dispatch(addInfoNotification('Pool thresholds were successfully deleted'))
          }
          else{
            dispatch(addErrorNotification('Error deleting pool thresholds', response.statusText))
          }
        })
        .catch(error => {
          dispatch(addErrorNotification('Error deleting pool thresholds', error.message))
          console.log('Catch fetch error: ', error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/poolThresholds.js